import React from "react";
import "./Home.css";
import { FaLinkedin } from "react-icons/fa";

const Aboutus = () => {
  function handleLinkedInClick() {
    window.open("https://www.linkedin.com/in/alghamdiasim?originalSubdomain=sa", "_blank");
  }

  return (
    <div className="about-ogits-container">
      <div className="about-content-wrapper">
        
        {/* Left Section: Image with hover effect */}
        <div className="about-image card" style={{ position: "relative", width: "fit-content" }}>
          
          
          {/* Hover content */}
          <div className="hover-content" onClick={handleLinkedInClick}>
            <div className="linkbut">
              <FaLinkedin className="linkedinbtn" />
            </div>
          </div>
        </div>

        {/* Right Section: Content */}
        <div className="about-content">
          <h2>
            Welcome to the Open Global Information Technology Solutions (OGITS)
          </h2>
          <p>
            <i>
              "Where our vision is to be a pioneering force in advancing information technology.  leverage innovative partnerships and cutting-edge technologies to transform data into actionable insights.
            </i>
          </p>
          <p>
            <i>
              Our goals encompass establishing a trusted presence in services, developing tailored governance frameworks, and creating high-quality data products that meet market needs. Join us on this exciting journey as we foster collaboration and drive sustainable development through the power of information."
            </i>
          </p>
          <h3>OGITS Founder Asim AlGhamdi</h3>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
